export default class NewWorkersReportRequest {
    shiftWeekCommencing: string;
}